import React from 'react';
import { PropTypes } from 'prop-types';
import Formsy from 'formsy-react';
import FormsyInput from './form/FormsyInput';
import Checkbox from './form/FormsyCheckbox';
import FormRadio from './form/Radio';
import withTracker from './withTracker';

class StyleGuide extends React.Component {
  state = {
    cb_op1: false,
    cb_op2: false,
    cb_op3: false,
    cb_op4: false,
    cb_op5: false,
    cb_op6: false,
    cb_op7: false,
    cb_op8: false,
    cb_op11: false,
    cb_op12: false,
    cb_op13: false,
    cb_op14: false,
    cb_op15: false,
    cb_op16: false,
    cb_op17: false,
    cb_op18: false,
    radio1: '',
    radio2: '',
    radio3: '',
    radio4: '',
    firstName: '',
    password: '',
    passwordConfirm: ''
  };

  render() {
    const { handleChange } = this;
    const {
      cb_op1,
      cb_op2,
      cb_op3,
      cb_op4,
      cb_op5,
      cb_op6,
      cb_op7,
      cb_op8,
      cb_op11,
      cb_op12,
      cb_op13,
      cb_op14,
      cb_op15,
      cb_op16,
      cb_op17,
      cb_op18,
      radio1,
      radio2,
      radio3,
      radio4,
      firstName,
      password,
      passwordConfirm
    } = this.state;
    const validationErrors = {
      equalsField: 'The passwords do not match.',
      minLength: 'Password must be 8 characters.',
      maxLength: 'Password cannot be 20 characters.'
    };

    const options = [
      { label: 'Option 1', value: '1' },
      { label: 'Option 2', value: '2' },
      { label: 'Option 3', value: '3' },
      { label: 'Option 4', value: '4' }
    ];

    return (
      <div className="style-guide">
        <div className="style-guide__group">
          <h1 className="h1">Heading L</h1>
          <h2 className="h2">Heading M</h2>
          <h3 className="h3">Heading S</h3>
          <h4 className="h4">Heading XS</h4>
          <p className="p">Text</p>
          <p className="small">Small Text</p>
          <a className="a">Link</a>
        </div>
        <div className="style-guide__group">
          <button className="btn btn--solid-green">Primary Button</button>
          <button className="btn btn--solid-green" disabled>
            Primary Button | Disabled
          </button>
          <br />
          <br />
          <a className="btn btn--hollow-green">Secondary Button</a>
          <a className="btn btn--hollow-green disabled">
            Secondary Button | Disabled
          </a>
        </div>
        <div className="style-guide__group style-guide__group--dark">
          <a className="btn btn--solid-white">Primary Button</a>
          <a className="btn btn--solid-white disabled">
            Primary Button | Disabled
          </a>
          <br />
          <br />
          <button className="btn btn--hollow-white">Secondary Button</button>
          <button className="btn btn--hollow-white" disabled>
            Secondary Button | Disabled
          </button>
        </div>
        <div className="style-guide__group">
          <Formsy className="style-guide__form form">
            <div className="input-row">
              <FormsyInput
                type="text"
                name="firstName"
                placeholder="First Name"
                value={firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-row">
              <FormsyInput
                type="password"
                name="password"
                placeholder="Password"
                value={password}
                onChange={handleChange}
                validations={'minLength:8,maxLength:20'}
                validationErrors={validationErrors}
                showValid
                required
              />
              <FormsyInput
                type="password"
                name="passwordConfirm"
                placeholder="Password Confirm"
                value={passwordConfirm}
                onChange={handleChange}
                validations={'equalsField:password'}
                validationErrors={validationErrors}
                showValid
                required
              />
            </div>
          </Formsy>
        </div>
        <div className="style-guide__group">
          <Formsy className="style-guide__form form">
            <div className="checkbox-group">
              <h3 className="h3">Checkbox Small - Block</h3>
              <Checkbox
                name="cb_op1"
                checked={cb_op1}
                placeholder="Option 1"
                onChange={handleChange}
                required
              />
              <Checkbox
                name="cb_op2"
                checked={cb_op2}
                placeholder="Option 2"
                onChange={handleChange}
              />
              <Checkbox
                name="cb_op3"
                checked={cb_op3}
                placeholder="Option 3"
                onChange={handleChange}
              />
              <Checkbox
                name="cb_op4"
                checked={cb_op4}
                placeholder="Option 4"
                onChange={handleChange}
              />
            </div>
            <div className="checkbox-group">
              <h3 className="h3">Checkbox Small - Inline</h3>
              <Checkbox
                name="cb_op5"
                checked={cb_op5}
                placeholder="Option 1"
                className="checkbox--small checkbox--inline"
                onChange={handleChange}
                required
              />
              <Checkbox
                name="cb_op6"
                checked={cb_op6}
                placeholder="Option 2"
                className="checkbox--small checkbox--inline"
                onChange={handleChange}
              />
              <Checkbox
                name="cb_op7"
                checked={cb_op7}
                placeholder="Option 3"
                className="checkbox--small checkbox--inline"
                onChange={handleChange}
              />
              <Checkbox
                name="cb_op8"
                checked={cb_op8}
                placeholder="Option 4"
                className="checkbox--small checkbox--inline"
                onChange={handleChange}
              />
            </div>

            <div className="checkbox-group">
              <h3 className="h3">Checkbox Large - Block</h3>
              <Checkbox
                name="cb_op11"
                checked={cb_op11}
                placeholder="Option 1"
                className="checkbox--large"
                onChange={handleChange}
              />
              <Checkbox
                name="cb_op12"
                checked={cb_op12}
                placeholder="Option 2"
                className="checkbox--large"
                onChange={handleChange}
              />
              <Checkbox
                name="cb_op13"
                checked={cb_op13}
                placeholder="Option 3"
                className="checkbox--large"
                onChange={handleChange}
              />
              <Checkbox
                name="cb_op14"
                checked={cb_op14}
                placeholder="Option 4"
                className="checkbox--large"
                onChange={handleChange}
              />
            </div>
            <div className="checkbox-group">
              <h3 className="h3">Checkbox Large - Inline</h3>
              <Checkbox
                name="cb_op15"
                checked={cb_op15}
                placeholder="Option 1"
                className="checkbox--large checkbox--inline"
                onChange={handleChange}
              />
              <Checkbox
                name="cb_op16"
                checked={cb_op16}
                placeholder="Option 2"
                className="checkbox--large checkbox--inline"
                onChange={handleChange}
              />
              <Checkbox
                name="cb_op17"
                checked={cb_op17}
                placeholder="Option 3"
                className="checkbox--large checkbox--inline"
                onChange={handleChange}
              />
              <Checkbox
                name="cb_op18"
                checked={cb_op18}
                placeholder="Option 4"
                className="checkbox--large checkbox--inline"
                onChange={handleChange}
              />
            </div>
          </Formsy>
        </div>

        <div className="style-guide__group">
          <Formsy className="style-guide__form form">
            <FormRadio
              name="radio1"
              options={options}
              value={radio1}
              onChange={handleChange}
              placeholder="Radio Small - Block"
              required
            />
            <FormRadio
              className="radio--inline"
              name="radio2"
              options={options}
              value={radio2}
              onChange={handleChange}
              placeholder="Radio Small - Inline"
              required
            />
            <FormRadio
              className="radio--large"
              name="radio3"
              options={options}
              value={radio3}
              onChange={handleChange}
              placeholder="Radio Large - Block"
              required
            />
            <FormRadio
              className="radio--large radio--inline"
              name="radio4"
              options={options}
              value={radio4}
              onChange={handleChange}
              placeholder="Radio Large - Inline"
              required
            />
          </Formsy>
        </div>
      </div>
    );
  }

  handleChange = e => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({ [name]: value });
  };

  static contextTypes = {
    router: PropTypes.object
  };
}

// export default withRouter(Login);
export default withTracker(StyleGuide);



// WEBPACK FOOTER //
// ./src/components/StyleGuide.js